/* eslint-disable no-unused-vars */
/* eslint-disable no-use-before-define */
import { toastSuccess, toastError } from './alertActions';
import { companyConstants } from '../constants/companyConstants';
import companyServices from '../services/companyServices';

function getCompany(companyId) {
  return (dispatch) => {
    dispatch(request(companyId));
    companyServices.getCompanyById(companyId)
      .then(
        (company) => {
          sessionStorage.setItem('company', JSON.stringify(company));
          dispatch(success(company));
        },
        (error) => {
          dispatch(failure(error.toString()));
          toastError(error.toString());
        },
      );
  };

  function request(company) { return { type: companyConstants.GET_COMPANY_REQUEST, company }; }
  function success(company) { return { type: companyConstants.GET_COMPANY_SUCCESS, company }; }
  function failure(error) { return { type: companyConstants.GET_COMPANY_FAILURE, error }; }
}

function newCompany(company) {
  return (dispatch) => {
    dispatch(request(company.name));
    companyServices.newCompany(company)
      .then(
        (comp) => {
          dispatch(success());
          toastSuccess(`${comp.name} created with success`);
        },
        (error) => {
          dispatch(failure(error.toString()));
          toastError(error.toString());
        },
      );
  };

  function request(comp) { return { type: companyConstants.CREATE_COMPANY_REQUEST, comp }; }
  function success() { return { type: companyConstants.CREATE_COMPANY_SUCCESS }; }
  function failure(error) { return { type: companyConstants.CREATE_COMPANY_FAILURE, error }; }
}

function updateCompany(companyId, data) {
  return (dispatch) => {
    dispatch(request(data.name));
    companyServices.updateCompany(companyId, data)
      .then(
        (company) => {
          dispatch(success(company));
          toastSuccess('Company updated with success');
        },
        (error) => {
          dispatch(failure(error.toString()));
          toastError(error.toString());
        },
      );
  };
  function request() { return { type: companyConstants.UPDATE_COMPANY_REQUEST }; }
  function success(company) { return { type: companyConstants.UPDATE_COMPANY_SUCCESS, company }; }
  function failure(error) { return { type: companyConstants.UPDATE_COMPANY_FAILURE, error }; }
}

function deleteCompany(companyId) {
  return (dispatch) => {
    dispatch(request(companyId));
    companyServices.deleteCompany(companyId)
      .then(
        () => {
          dispatch(success());
          toastSuccess('Company deleted with success');
        },
        (error) => {
          dispatch(failure(error.toString()));
          toastError(error.toString());
        },
      );
  };
  function request(company) { return { type: companyConstants.DELETE_COMPANY_REQUEST, company }; }
  function success() { return { type: companyConstants.DELETE_COMPANY_SUCCESS }; }
  function failure(error) { return { type: companyConstants.DELETE_COMPANY_FAILURE, error }; }
}

function unsetCompany() {
  return (dispatch) => {
    sessionStorage.removeItem('company');
    dispatch({ type: companyConstants.UNSET_COMPANY });
  };
}

function setCompany(company) {
  return (dispatch) => {
    sessionStorage.setItem('company', JSON.stringify(company));
    dispatch({ type: companyConstants.SET_COMPANY, company });
  };
}

const companyActions = {
  getCompany,
  newCompany,
  updateCompany,
  deleteCompany,
  unsetCompany,
  setCompany,
};

export default companyActions;
